module.exports = "/fast-coin/img/coin/anim/in/coin_in_007.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_007.png
// module id = 2277
// module chunks = 5